import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Section, SectionHeading } from './ui/Section';
import { FiTarget } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const TargetAudience = () => {
  const { t } = useLanguage();

  return (
    <Section id="target" bg="bg-brand-darker border-y border-brand-border/30">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <SectionHeading>{t.target.heading}</SectionHeading>
        <p className="text-xl text-brand-textMuted mt-6">{t.target.body}</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 max-w-5xl mx-auto">
        {t.target.items.map((item, index) => (
          <div key={index} className="flex flex-col items-center text-center">
             <div className="w-12 h-12 rounded-full bg-brand-card border border-brand-border flex items-center justify-center mb-4">
                <SafeIcon icon={FiTarget} className="w-5 h-5 text-brand-accent" />
             </div>
             <h4 className="text-lg font-bold text-brand-textHeading mb-2">{item.title}</h4>
             <p className="text-brand-textMuted text-sm">{item.desc}</p>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default TargetAudience;